export default {
  pedidosArray: [],
  pedidosRealizandoTpv: [], //para boss_negocio y boss_restaurante
  pedidosPendienteConfirmacionPago: [],
  pedidosEliminar: [],
  diaComprobando1: null, //inicio rango
  diaComprobando2: null, //fin rango,
  eliminarMotivos: [
    {
      text: 'Pruebas',
      value: 'pruebas',
      icon: 'mdi-test-tube'
    },
    {
      text: 'Solicitado por dueño negocio',
      value: 'solicitado-negocio',
      icon: 'mdi-store'
    },
    {
      text: 'Solicitado por el usuario',
      value: 'solicitado-usuario',
      icon: 'mdi-account'
    },
    {
      text: 'Fallo de la aplicación',
      value: 'fallo-aplicacion',
      icon: 'mdi-bug'
    }, {
      text: 'Pasar a otro restaurante',
      value: 'pasar',
      icon: 'mdi-store'
    },
  ]

}